(function () {
  function smoothScrollToAnchor(anchorId) {
    var target = document.getElementById(anchorId);
    console.log('[smooth-anchor] target #' + anchorId + ':', target);
    if (!target) return false;
    var rect = target.getBoundingClientRect();
    var styleMarginTop = parseInt(window.getComputedStyle(target).scrollMarginTop, 10);
    if (isNaN(styleMarginTop) || styleMarginTop <= 0) {
      styleMarginTop = 80;
    }
    var pageY = rect.top + window.pageYOffset;
    var targetY = pageY - styleMarginTop;
    if (targetY < 0) targetY = 0;
    console.log('[smooth-anchor] target pageY=' + pageY + ', currentScrollY=' + window.pageYOffset + ', scrollMarginTop=' + styleMarginTop + ', scrolling to=' + targetY);
    window.scrollTo({ top: targetY, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href*="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var anchorId = href.slice(hashIndex + 1);
    if (!anchorId) return;

    var hrefPath = href.slice(0, hashIndex);
    if (hrefPath && hrefPath !== window.location.pathname && hrefPath !== window.location.pathname.replace(/\/$/, '')) {
      return;
    }

    if (smoothScrollToAnchor(anchorId)) {
      event.preventDefault();
      try { history.pushState(null, '', '#' + anchorId); } catch (_) {}
    }
  });

  if (window.location.hash) {
    setTimeout(function () {
      var anchorId = window.location.hash.slice(1);
      if (anchorId) smoothScrollToAnchor(anchorId);
    }, 50);
  }
})();
